// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__b12Te","balanceDisclaimer":"posDashboard_balanceDisclaimer__36spV"};